import { connect } from "react-redux";
import { sessionSlice } from "../../store/sessionSlice";
import CreateView from "../views/create";

const mapStateToProps = (state) => {
  return {
    isConnected: state.session.isConnected,
    isConnectedToASession: state.session.sessionStatus === "ACTIVE" || state.session.sessionStatus === "MINIMIZING",
    isLoading: state.session.sessionStatus === "LOADING_ROOM" || state.session.sessionStatus === "LOADING_SCENE",
    isSetupError: state.session.sessionStatus === "SETUP_ERROR",
    errorMsg: state.session.sessionMsg,
    isEstablishingConnection: state.session.isEstablishingConnection,
    connectionQualityFailed: state.session.connectionQuality.status === "failed",
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onStartConnecting: (data) => {
      dispatch(sessionSlice.actions.startConnecting());
    },
     onTryAgain: () => {
      dispatch(sessionSlice.actions.tryAgain());
    },
  };
};
export const CreateViewContainer = connect(mapStateToProps, mapDispatchToProps)(CreateView);
